<template>
    <flickity :options="flickityOptions" class="orsus-advisors" ref="advisors">
        <div v-for="(item, index) in advisors" :key="index" class="carousel-cell w-full mx-2 md:mx-4 relative">
            <div class="px-6 md:px-0">
                <img :src="item.image_path" class="block mx-auto mb-6 w-full" alt="">
                <div>
                    <div class="mb-6">
                        <div class="flex justify-between">
                            <h3 class="text-xl">{{ item.name }}</h3>
                            <a href="#">
                                <img src="/assets/images/icons/linkedin.svg" class="w-6 h-6" alt="LinkedIn Icon">
                            </a>
                        </div>
                        <span class="font-light">{{ item.role }}</span>
                    </div>
                    <p class="font-light mb-2">{{ item.description }}</p>
                    <button type="button" class="text-warm-blue font-bold text-lg" aria-label="Read more" @click="$modal.show('pop-up-' + index);">Read more</button>
                </div>
            </div>
        </div>
    </flickity>
</template>

<script>
import Flickity from 'vue-flickity';

export default {
    data() {
        return {
            flickityOptions: {
                imagesLoaded: true,
                prevNextButtons: false,
                contain: true,
                groupCells: true
            }
        }
    },
    components: {
        Flickity
    },
    props: {
        advisors: {
            type: Array,
            default: {}
        }
    },
}
</script>


